const accordionBlocks = document.querySelectorAll('.accordion-item');
const accordionHiddenElements = document.querySelectorAll('.accordion-item > .accordion-item__hidden');
const accordionShownElements = document.querySelectorAll('.accordion-item > .accordion-item__shown');

accordionShownElements.forEach(shownEl => {
  shownEl.addEventListener('click', () => toggleAccordion(shownEl));

  shownEl.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleAccordion(shownEl);
    }
  });
});

function toggleAccordion(shownEl) {
  const parent = shownEl.parentElement;
  const isOpen = parent.classList.contains('accordion-item_open');

  accordionHiddenElements.forEach(hiddenEl => {
    hiddenEl.style.height = '0';
  });
  accordionBlocks.forEach(block => {
    block.classList.remove('accordion-item_open');
    const head = block.querySelector('.accordion-item__shown[role="button"]');
    if (head) head.setAttribute('aria-expanded', 'false');
  });

  if (!isOpen) {
    const hiddenEl = shownEl.nextElementSibling;
    if (hiddenEl) {
      hiddenEl.style.height = hiddenEl.scrollHeight + 'px';
    }
    parent.classList.add('accordion-item_open');
    shownEl.setAttribute('aria-expanded', 'true');
  }
}
